export { default } from './footer'